<template>
    <el-form label-width="180px" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="手机号" required>
            <el-input v-model="form.phone" />
        </el-form-item>
        <el-form-item label="御" required>
            <el-input v-model="form.yu" />
        </el-form-item>
        <el-form-item label="享" required>
            <el-input v-model="form.xiang" />
        </el-form-item>
        <el-form-item label="臻" required>
            <el-input v-model="form.zhen" />
        </el-form-item>
        <el-form-item label="品" required>
            <el-input v-model="form.pin" />
        </el-form-item>
        <el-form-item label="行" required>
            <el-input v-model="form.xing" />
        </el-form-item>
        <el-form-item label="稳" required>
            <el-input v-model="form.wen" />
        </el-form-item>
        <el-form-item label="致" required>
            <el-input v-model="form.zhi" />
        </el-form-item>
        <el-form-item label="远" required>
            <el-input v-model="form.yuan" />
        </el-form-item>
        <el-form-item label="幸运抽奖预设" v-if="raffleOptions.length > 0" required>
            <el-select v-model="form.next" placeholder="幸运抽奖预设" clearable>
                <el-option v-for="item in raffleOptions.filter(item => item.type == 1)" :key="item.id" :label="`${item.title}（${item.words}）`" :value="item.id" />
            </el-select>
        </el-form-item>
        <el-form-item label="抽大奖预设" v-if="bigRaffleOptions.length > 0">
            <el-select v-model="form.next_prize" placeholder="抽大奖预设" clearable>
                <el-option v-for="item in bigRaffleOptions" :key="item.id" :label="`${item.title}（${item.money}）`" :value="item.id" />
            </el-select>
        </el-form-item>
    </el-form>
</template>

<script setup>
import { nextTick, onMounted, ref, getCurrentInstance } from 'vue'
import { withdrawTypeEnums, getLabelByVal } from '@/config/enums'

const form = ref({
    phone: "",
    yu: "",
    xiang: "",
    zhen: "",
    pin: "",
    xing: "",
    wen: "",
    zhi: "",
    yuan: "",
    next: "",
    next_prize: "",
})
const props = defineProps(['item'])

onMounted(() => {
    nextTick(() => {
        form.value = Object.assign(form, props.item)
        loadRaffles()
        loadBigRaffles()
    })
})

const raffleOptions = ref([])
const bigRaffleOptions = ref([])

const { proxy } = getCurrentInstance()
const loadRaffles = async () => {
  const res = await proxy.$http({
    method: 'get',
    url: '/Raffle/getRaffleLists',
    params: {
      page: 1,
      limit: 1000,
    }
  })
  if (res.code === 0) {
    raffleOptions.value = res.data.data || []
  }
}

const loadBigRaffles = async () => {
  const res = await proxy.$http({
    method: 'get',
    url: '/RaffleBig/getRaffleLists',
    params: {
      page: 1,
      limit: 1000,
    }
  })
  if (res.code === 0) {
    bigRaffleOptions.value = res.data.data || []
  }
}

defineExpose({ form })

</script>

<style lang="less" scoped>
.demo-form-inline {
    justify-content: flex-start;
    display: flex;
    flex-wrap: wrap;
}

.demo-form-inline .el-input {
    --el-input-width: 220px;
}

.demo-form-inline .el-select {
    --el-select-width: 220px;
}

/deep/ .el-radio-group {
    width: 220px;
}

.form-title {
    text-align: left;
    padding-left: 30px;
    margin: 20px auto 10px;
    height: 44px;
    background-color: #f2f2f2;
    border-radius: 5px;
    line-height: 44px;
    width: 100%;
}

/deep/ .el-form-item {
    align-items: flex-start;
}
</style>
